'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useCloset } from '@/contexts/ClosetContext';
import { transformClosetItem } from '@/lib/closet/transforms';
import { fetchOutfits } from '@/lib/closet/api-client';
import type { Outfit } from '@/types/closet';
import { LookbookView } from './LookbookView';
export function LookbookCollection(t0) {
  const $ = _c(12);
  const {
    initialOutfits,
    savedOutfits: t1,
    searchQuery,
    initialId,
    onCreate
  } = t0;
  const savedOutfits = t1 === undefined ? [] : t1;
  const {
    items
  } = useCloset();
  const [outfits, setOutfits] = useState(initialOutfits);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = node => {
      if (!node) {
        return;
      }
      let mounted = true;
      fetchOutfits().then(outfits_0 => {
        if (mounted) {
          setOutfits(outfits_0);
        }
      }).catch(_temp);
      return () => {
        mounted = false;
      };
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const refreshOutfits = t2;
  const t3 = "lookbook-collection";
  const T0 = LookbookView;
  const t4 = [...outfits, ...savedOutfits.filter(saved => !outfits.some(outfit => outfit.id === saved.id))].filter(outfit_0 => outfit_0.name.toLowerCase().includes(searchQuery.toLowerCase()));
  let t5;
  if ($[1] !== items) {
    t5 = items.map(transformClosetItem);
    $[1] = items;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== T0 || $[4] !== initialId || $[5] !== onCreate || $[6] !== t4 || $[7] !== t5) {
    t6 = <T0 initialId={initialId} onCreate={onCreate} outfits={t4} items={t5} />;
    $[3] = T0;
    $[4] = initialId;
    $[5] = onCreate;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== refreshOutfits || $[10] !== t6) {
    t7 = <div className={t3} ref={refreshOutfits}>{t6}</div>;
    $[9] = refreshOutfits;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
function _temp() {}